module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_9006.8f4161c3.png";